export enum DataSourceTypes {
    FILE_CSV = "FILE_CSV",
    SHOPIFY = "SHOPIFY",
    FACEBOOK_MARKETING = "FACEBOOK_MARKETING",
    GOOGLE_ADS = "GOOGLE_ADS"
}
